<template>
    <p class="text-gray-700">
        <i18n-t keypath="widget.step_counter" tag="span">
            <template #currentStep>
                <strong>{{ getCurrentStep() }}</strong>
            </template>
            <template #totalSteps>
                <strong>{{ getMaxStepCount() }}</strong>
            </template>
        </i18n-t>
    </p>
</template>

<script setup lang="ts">
import { inject } from 'vue'

const { getCurrentStep, getMaxStepCount } = inject('navigation')
</script>
